// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductDashboardGallery_root__c_sK0","withThumbnails":"ProductDashboardGallery_withThumbnails__xIb_w","measuring":"ProductDashboardGallery_measuring__zUtIG"};